module.exports = __webpack_public_path__ + "img/btn2.95f3fb49.png";